import { t } from "../i18n"
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.element.textContent = t('javascript.controllers.hello_controller.hello_world')
  }
}
